

















































































































































































































































































import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
/* component */
import ConfirmModal from '@/app/components/Common/ConfirmModal.vue'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import DateClass from '@/app/module/date'
import { userType } from '@/app/model/store/domain/const'
/* api */
import fertilizerCreateApi from '@/app/model/api/fertilizerCreateApi'
import fertilizerUpdateApi from '@/app/model/api/fertilizerUpdateApi'

@Component({
  components: {
    Graph: () => import('@/app/components/FieldDetails/Graph.vue'),
    ConfirmModal
  }
})
export default class Fertilization extends Vue {
  private fertilizerType: string = ''
  private weatherCondition: string = ''
  private message1st: string = ''
  private param1st: any = {
    plantHeight: null,
    spad: null,
    timeStamp: null
  }
  private param3rd_10: any = {
    plantHeight: null,
    spad: null,
    timeStamp: null
  }
  private param3rd_6: any = {
    plantHeight: null,
    spad: null,
    timeStamp: null
  }
  private param3rd_3: any = {
    plantHeight: null,
    spad: null,
    timeStamp: null
  }
  private judge1stResult: any = null
  private judge3rd_10Result: any = null
  private judge3rd_6Result: any = null
  private judge3rd_3Result: any = null
  private currentDate: string = ''
  private estYpfDate: string = ''
  private actYpfDate: string = ''
  private headingDate: string = ''
  private message3rd: string = ''
  private remainingDaysToHeading: number|null = null
  private fertilizerTypeList: any[] = [
    { key: 'organic', dispName: '有機肥料' },
    { key: 'chemical', dispName: '化学肥料' }
  ]
  private weatherConditionList: any[] = [
    { key: 'rainy', dispName: '低温・少照・多雨' },
    { key: 'normal', dispName: '平年並み' },
    { key: 'sunny', dispName: '高温・多照・少雨' }
  ]
  private showConfirmModal: boolean = false
  private isViewer = false

  private get forceDateChangeFlag (): boolean {
    return this.$store.state.dateChoiceState.forceChangeDateFlag
  }
  @Watch('forceDateChangeFlag')
  onForceDateChangeed (flag: boolean) {
    if (!flag) {
      return
    }
    this.onDateChange(this.$store.state.dateChoiceState.changeDate)
  }
  private get dateChangeState (): number {
    return this.$store.state.dateChoiceState.changeDate
  }
  @Watch('dateChangeState')
  onDateChange (date: string) {
    this.currentDate = date
    this.message3rd = ''
    this.remainingDaysToHeading = this.getRemainingDaysToHeading()
  }
  private get watchStageData (): any[] {
    return this.$store.state.fieldDetailsState.stageData
  }
  @Watch('watchStageData')
  private onStageDataChanged (stageData: any[]) {
    const growthList = JSON.parse(Session.getGrowthStage()!)
    for (const i in stageData) {
      if (stageData[i].growth_stage_name.includes('幼穂形成期')) {
        if (growthList[i].growth_stage_histories.length === 0) {
          this.estYpfDate = '' + stageData[i].stage_date
        } else {
          this.actYpfDate = '' + stageData[i].stage_date
          this.estYpfDate = '' + stageData[i].stage_date
        }
      } else if (stageData[i].growth_stage_name.includes('出穂期')) {
        this.headingDate = '' + stageData[i].stage_date
      }
    }
  }

  // DetailsContentから呼ばれる
  public onSensorDataChanged () {
    const fertilizer = JSON.parse(Session.getFertilizer()!) || {}
    this.fertilizerType = fertilizer.fertilizer_type ? this.fertilizerTypeList[fertilizer.fertilizer_type - 1].key : ''
    this.weatherCondition = fertilizer.weather_condition ? this.weatherConditionList[fertilizer.weather_condition - 1].key : ''

    this.reset()
    const plantingId = Session.getPlantingId()!
    const sensorDataList = JSON.parse(Session.getSensorData(plantingId)!) || []
    if (this.actYpfDate !== '') {
      this.param1st = this.getParamFromSensorData(sensorDataList.find((s: any) => s.date === parseInt(this.actYpfDate)))
    }
    this.param3rd_10 = this.getParamFromSensorData(sensorDataList.find((s: any) => s.date === parseInt(this.getPastDateFromHeadingDate(10) || '0')))
    this.param3rd_6 = this.getParamFromSensorData(sensorDataList.find((s: any) => s.date === parseInt(this.getPastDateFromHeadingDate(6) || '0')))
    this.param3rd_3 = this.getParamFromSensorData(sensorDataList.find((s: any) => s.date === parseInt(this.getPastDateFromHeadingDate(3) || '0')))

    if (this.validate1st(true)) {
      this.judge1st()
    }
    this.update1stGraph()
    for (const step of [10, 6, 3]) {
      this.remainingDaysToHeading = step
      if (this.validate3rd(true)) {
        this.judge3rd()
      }
    }
    this.remainingDaysToHeading = this.getRemainingDaysToHeading()
  }

  private reset () {
    const initialParam = this.getParamFromSensorData(null)
    this.param1st = initialParam
    this.param3rd_10 = initialParam
    this.param3rd_6 = initialParam
    this.param3rd_3 = initialParam
    this.judge1stResult = null
    this.judge3rd_10Result = null
    this.judge3rd_6Result = null
    this.judge3rd_3Result = null
  }

  private getParamFromSensorData (sensorData: any) {
    if (sensorData) {
      return {
        plantHeight: sensorData.growth_status.plant_height,
        spad: sensorData.nutrition_status.spad,
        timeStamp: sensorData.time_stamp
      }
    } else {
      return {
        plantHeight: null,
        spad: null,
        timeStamp: null
      }
    }
  }

  private isDisabledParams () {
    return this.actYpfDate === ''
  }

  private displayActYpfDate () {
    return DateClass.displayData(parseInt(this.actYpfDate))
  }

  private toDispString (str: string|number) {
    // 半角数字を全角に変換
    return `${str}`.replace(/[0-9]/g, (s) => String.fromCharCode(s.charCodeAt(0) + 0xFEE0))
  }

  private getRemainingDaysToHeading () {
    if (this.headingDate === '' || this.currentDate === '') {
      return null
    }
    const diff = DateClass.formingDate(this.headingDate).getTime() - DateClass.formingDate(this.currentDate).getTime()
    return diff / (24 * 60 * 60 * 1000)
  }

  private getStepOfRemainingDaysToHeading () {
    if (!this.remainingDaysToHeading && this.remainingDaysToHeading !== 0) {
      return null
    } else if (this.remainingDaysToHeading > 10) {
      return null
    } else if (this.remainingDaysToHeading >= 7) {
      return 10
    } else if (this.remainingDaysToHeading >= 4) {
      return 6
    } else {
      return 3
    }
  }

  private getPastDateFromHeadingDate (num: number) {
    if (this.headingDate === null) {
      return null
    }
    return DateClass.dateToStringYmd(new Date(DateClass.formingDate(this.headingDate).getTime() - (24 * 60 * 60 * 1000 * num)), 'yyyyMMdd')
  }

  private getParam3rd () {
    switch (this.getStepOfRemainingDaysToHeading()) {
      case 10: return this.param3rd_10
      case 6: return this.param3rd_6
      case 3: return this.param3rd_3
      default: return null
    }
  }

  private getJudge3rdResult () {
    switch (this.getStepOfRemainingDaysToHeading()) {
      case 10: return this.judge3rd_10Result
      case 6: return this.judge3rd_6Result
      case 3: return this.judge3rd_3Result
      default: return null
    }
  }

  private setJudge3rdResult (result: any) {
    switch (this.getStepOfRemainingDaysToHeading()) {
      case 10: this.judge3rd_10Result = result; break
      case 6: this.judge3rd_6Result = result; break
      case 3: this.judge3rd_3Result = result; break
    }
  }

  private async store (param: any, date: string) {
    const plantingID = Session.getPlantingId()!
    const fertilizer = JSON.parse(Session.getFertilizer()!) || {}
    const bodyData = {
      'fertilizer_type': this.fertilizerTypeList.findIndex((e) => e.key === this.fertilizerType) + 1,
      'weather_condition': this.weatherConditionList.findIndex((e) => e.key === this.weatherCondition) + 1,
      'time_stamp': fertilizer.time_stamp || -1,
      'record_date': date,
      'plant_height': param.plantHeight ? parseFloat(param.plantHeight) : null,
      'spad': param.spad ? parseFloat(param.spad) : null,
      'planting_record_time_stamp': param.timeStamp || -1
    }
    this.$emit('show-loading')
    let result
    if (fertilizer.time_stamp) {
      result = await fertilizerUpdateApi.update(bodyData, plantingID)
    } else {
      result = await fertilizerCreateApi.create({ ...bodyData, ...{ planting_id: parseInt(plantingID) } })
    }
    this.$emit('disable-loading')
    return result
  }

  private validateNumberParam (value: any, name: string, min: number, max: number, numberOfDecimals: number) {
    if (value === null || value === '') {
      return [`${name}を入力してください`]
    }
    const v = parseFloat(`${value}`)
    if (isNaN(v) || v < min || max < v) {
      return [`${name}は${min}以上${max}以下の数値で入力してください`]
    } else if ([...`${v}`.split('.'), ''][1].length > numberOfDecimals) {
      if (numberOfDecimals === 0) {
        return [`${name}は整数で入力してください。`]
      } else {
        return [`${name}は小数点第${numberOfDecimals}位までの範囲で入力してください。`]
      }
    }
    return []
  }

  private getConfirmMessage () {
    const createMessage = '<p>登録しますか？</p>'
    const updateMessage = '<p>更新しますか？</p>'
    if (this.getStepOfRemainingDaysToHeading() === null) {
      return this.judge1stResult === null ? createMessage : updateMessage
    } else {
      return createMessage
    }
  }

  private async save () {
    let result
    if (this.getStepOfRemainingDaysToHeading() === null) {
      result = await this.store1stParams()
    } else {
      result = await this.store3rdParams()
    }
    if (!result) {
      return
    }
    // グラフデータ再ロード
    this.$emit('reacquire-stage')
  }

  private async judge1stBtn () {
    if (!this.validate1st(false)) {
      return
    }
    this.showConfirmModal = true
  }

  private validate1st (checkOnly: boolean) {
    let messages: string[] = []
    if (this.fertilizerType.length === 0) {
      messages.push('肥料を選択してください')
    }
    if (this.weatherCondition.length === 0) {
      messages.push('気象判定を選択してください')
    }
    messages = [...messages, ...this.validateNumberParam(this.param1st.plantHeight, '草丈', 0, 200, 1)]
    messages = [...messages, ...this.validateNumberParam(this.param1st.spad, '葉色', 0, 200, 1)]
    const result = messages.length === 0
    if (!checkOnly) {
      this.message1st = messages.join('\n')
    }
    return result
  }

  private judge1st () {
    const calcFuncMap: any = {
      organic: (c: number) => c < 2400 ? 'A' : c >= 2400 && c < 2700 ? 'B' : 'C',
      chemical: (c: number) => c < 2500 ? 'A' : c >= 2500 && c < 2800 ? 'B' : 'C'
    }
    const level = calcFuncMap[this.fertilizerType](this.param1st.plantHeight! * this.param1st.spad!)
    const resultMap: any = {
      A: {
        levelValue: { organic: '2400未満', chemical: '2500未満' },
        message: { rainy: '時期遅め、量は控えめで施肥してください。', normal: '出穂18日前に基準量を施肥してください。', sunny: '出穂18日前に基準量を施肥してください。' }
      },
      B: {
        levelValue: { organic: '2400〜2700', chemical: '2500〜2800' },
        message: { rainy: '施肥は必要ありません。', normal: '施肥は必要ありません。', sunny: '出穂15日前に基準量を施肥してください。' }
      },
      C: {
        levelValue: { organic: '2700以上', chemical: '2800以上' },
        message: { rainy: '施肥は必要ありません。', normal: '施肥は必要ありません。', sunny: '異常高温の場合は出穂15日前に基準量を施肥してください。' }
      }
    }
    this.judge1stResult = {
      level: level,
      levelValue: resultMap[level].levelValue[this.fertilizerType],
      message: resultMap[level].message[this.weatherCondition]
    }
  }

  private update1stGraph () {
    const graph: any = this.$refs.fertilizationGraph
    if (!graph) {
      return
    }
    graph.updateGraph()
  }

  private async store1stParams () {
    const result = await this.store(this.param1st, this.actYpfDate)
    if (result.isOk()) {
      return true
    } else {
      this.message1st = '穂肥診断情報の更新に失敗しました'
      return false
    }
  }

  private async judge3rdBtn () {
    if (!this.validate3rd(false)) {
      return
    }
    this.showConfirmModal = true
  }

  private validate3rd (checkOnly: boolean) {
    let messages: string[] = []
    const step = this.getStepOfRemainingDaysToHeading()
    if (step === 10) {
      messages = [...messages, ...this.validateNumberParam(this.param3rd_10.spad, '葉色', 0, 200, 1)]
    } else if (step === 6) {
      messages = [...messages, ...this.validateNumberParam(this.param3rd_6.spad, '葉色', 0, 200, 1)]
    } else if (step === 3) {
      messages = [...messages, ...this.validateNumberParam(this.param3rd_3.spad, '葉色', 0, 200, 1)]
    }
    const result = messages.length === 0
    if (!checkOnly) {
      this.message3rd = messages.join('\n')
    }
    return result
  }

  private judge3rd () {
    const param = this.getParam3rd()
    const step = this.getStepOfRemainingDaysToHeading()
    const level = param.spad >= 33 ? 'A' : 'B'
    let messageMap: any
    if (step === 10) {
      messageMap = {
        A: { message1: '追加穂肥は必要ありません' },
        B: { message1: '特別栽培の場合、出穂期１０〜５日前頃に窒素成分<br>２ｋｇ/１０ａ　有機１００％肥料を用いてください<br><br>一般栽培の場合、出穂期までの葉色がSPAD値３２〜３３を下回ると予想される場合は、出穂期１０日前までに窒素成分　１ｋｇ/１０ａ　化学肥料を用いてください' }
      }[level]
    } else {
      messageMap = {
        A: { message1: '特別栽培の場合、穂肥は必要ありません' },
        B: { message1: '特別栽培の場合、出穂期６〜３日前に窒素成分<br>１ｋｇ/１０ａ　有機１００％肥料を穂肥しましょう', message2: '低地力ほ場については、農業普及指導センターやJAに相談してください' }
      }[level]
    }
    Object.keys(messageMap).forEach((e: string) => { messageMap[e] = messageMap[e].replaceAll('<br>', '\n') })
    this.setJudge3rdResult({ level: level, message: messageMap })
  }

  private async store3rdParams () {
    const result = await this.store(this.getParam3rd(), this.getPastDateFromHeadingDate(this.getStepOfRemainingDaysToHeading()!)!)
    if (result.isOk()) {
      return true
    } else {
      this.message3rd = '穂肥診断情報の更新に失敗しました'
      return false
    }
  }

  /// グラフ設定

  private plugin: any = {}
  private xTickData: number[] = Array.from({ length: 31 }, (_, i) => 60 + i)
  private chartData: any = {
    xLabels: this.xTickData,
    datasets: [
      {
        type: 'line',
        yAxisID: 'y-axis-0',
        spanGaps: true,
        backgroundColor: 'rgba(255, 255, 255, 1)',
        borderColor: 'rgba(32, 32, 32, 1)',
        borderWidth: 2,
        pointRadius: 3,
        pointBorderWidth: 1,
        pointBorderColor: 'rgba(32, 32, 32, 1)',
        pointBackgroundColor: 'rgba(255, 255, 255, 1)',
        data: this.xTickData.map((e) => e % 5 === 0 ? 2400 / e : null),
        lineTension: 0.3
      },
      {
        type: 'line',
        yAxisID: 'y-axis-0',
        spanGaps: true,
        backgroundColor: 'rgba(255, 255, 178, 1)',
        borderColor: 'rgba(32, 32, 32, 1)',
        borderDash: [5, 3],
        borderWidth: 2,
        pointStyle: 'rectRot',
        pointRadius: 3,
        pointBorderWidth: 1,
        pointBorderColor: 'rgba(32, 32, 32, 1)',
        pointBackgroundColor: 'rgba(255, 255, 255, 1)',
        data: this.xTickData.map((e) => e % 5 === 0 ? 2500 / e : null),
        lineTension: 0.3
      },
      {
        type: 'line',
        yAxisID: 'y-axis-0',
        spanGaps: true,
        backgroundColor: 'rgba(255, 255, 124, 1)',
        borderColor: 'rgba(32, 32, 32, 1)',
        borderWidth: 2,
        pointRadius: 3,
        pointBorderColor: 'rgba(32, 32, 32, 1)',
        pointBackgroundColor: 'rgba(32, 32, 32, 1)',
        data: this.xTickData.map((e) => e % 5 === 0 ? 2700 / e : null),
        lineTension: 0.3
      },
      {
        type: 'line',
        yAxisID: 'y-axis-0',
        spanGaps: true,
        backgroundColor: 'rgba(255, 194, 136, 1)',
        borderColor: 'rgba(32, 32, 32, 1)',
        borderDash: [5, 3],
        borderWidth: 2,
        pointStyle: 'rect',
        pointRadius: 4,
        pointBorderColor: 'rgba(32, 32, 32, 1)',
        pointBackgroundColor: 'rgba(32, 32, 32, 1)',
        data: this.xTickData.map((e) => e % 5 === 0 ? 2800 / e : null),
        lineTension: 0.3
      },
      {
        type: 'line',
        yAxisID: 'y-axis-0',
        backgroundColor: 'rgba(255, 116, 123, 1)',
        data: this.xTickData.map((e) => 50)
      }
    ]
  }

  private chartOptions: any = {
    responsive: true,
    animation: false,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    layout: {
      padding: {
        top: 0,
        left: 30,
        bottom: 0,
        right: 35
      }
    },
    scales: {
      xAxes: [
        {
          id: 'x-axis-0',
          scaleLabel: {
            display: true,
            labelString: '草丈(cm)',
            color: 'rgba(0, 0, 0, 1)',
            fontSize: 12
          },
          gridLines: {
            z: 10000,
            color: 'rgba(0, 0, 0, 0.4)'
          },
          ticks: {
            display: true,
            fontSize: 12,
            min: 60,
            max: 90,
            stepSize: 5,
            maxTicksLimit: 7,
            maxRotation: 0
          }
        },
        {
          id: 'x-axis-1',
          gridLines: {
            drawTicks: false,
            drawBorder: false,
            z: 10000,
            color: 'rgba(0, 0, 0, 0.2)'
          },
          ticks: {
            display: false
          }
        }
      ],
      yAxes: [
        {
          id: 'y-axis-0',
          scaleLabel: {
            display: true,
            labelString: 'SPAD',
            color: 'rgba(0, 0, 0, 1)',
            fontSize: 12
          },
          gridLines: {
            z: 10000,
            color: 'rgba(0, 0, 0, 0.4)'
          },
          ticks: {
            fontSize: 12,
            min: 28,
            max: 42,
            stepSize: 2
          },
          position: 'left'
        },
        {
          id: 'y-axis-1',
          gridLines: {
            drawTicks: false,
            drawBorder: false,
            z: 10000,
            color: 'rgba(0, 0, 0, 0.2)'
          },
          ticks: {
            display: false,
            min: 28,
            max: 42,
            stepSize: 0.4
          }
        }
      ]
    },
    plugins: [],
    annotation: {
      events: [],
      annotations: []
    },
    events: []
  }

  created () {
    switch (Number(Local.getUserType())) {
      case userType.USER_TYPE_VIEWER:
      case userType.USER_TYPE_ALL_VIEWER:
        this.isViewer = true
        break
    }
    const self: any = this
    this.plugin = {
      afterDraw (chart: any, args: any, options: any) {
        const ctx = chart.ctx
        const img = document.getElementById('graph-legend1')
        const xAxis = chart.scales['x-axis-0']
        const yAxis = chart.scales['y-axis-0']
        const left = xAxis.getPixelForValue(60)
        const right = xAxis.getPixelForValue(90)
        ctx.drawImage(img, right - 124, 10, 120, 60)
        if (!self.param1st.plantHeight || !self.param1st.spad || !self.judge1stResult) {
          return
        }
        const x = self.param1st.plantHeight
        const yPixel = yAxis.getPixelForValue(self.param1st.spad)
        ctx.lineWidth = 1
        ctx.strokeStyle = 'rgba(0, 0, 0, 1)'
        ctx.fillStyle = 'rgba(228, 16, 16, 0.8)'
        ctx.beginPath()
        ctx.arc((x - 60) / 30 * (right - left) + left, yPixel, 5, 0, 2 * Math.PI)
        ctx.stroke()
        ctx.fill()
      }
    }
  }
}
